"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dnifSchema = exports.dnifFileSchema = exports.dnifEstimateDurationSchema = void 0;
const yup = __importStar(require("yup"));
exports.dnifEstimateDurationSchema = yup.object().shape({
    duration: yup.number().required(),
    unit: yup.string().required(),
});
exports.dnifFileSchema = yup.object().shape({
    id: yup.string().required(),
    url: yup.string().required(),
    name: yup.string().required(),
});
exports.dnifSchema = yup.object().shape({
    id: yup.string().required(),
    name: yup.string().required(),
    aircrewId: yup.string().required(),
    squadronName: yup.string().required(),
    squadronId: yup.string().required(),
    position: yup.string().required(),
    aircrewType: yup.string().required(),
    effectiveDate: yup.date().required(),
    actualReturn: yup.date().nullable().optional().notRequired(),
    estimatedDuration: exports.dnifEstimateDurationSchema,
    estimatedReturn: yup.date().required(),
    canParticipateInSimEvents: yup.boolean().default(false).required(),
    canParticipateInGroundEvents: yup.boolean().default(false).required(),
    fileReference: exports.dnifFileSchema.nullable().optional().notRequired(),
});
